;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .factory('orgTraceApiConfig', orgTraceApiConfigFactory)

  function orgTraceApiConfigFactory($http, $q, UserService) {
    'ngInject'

    return {
      getVulnerability: getVulnerability,
      getVulnerabilityShort: getVulnerabilityShort,
      getVulnerabilityVisibility: getVulnerabilityVisibility,
      markStatus: markStatus,
      shareViaEmail: shareViaEmail,
      deleteTraces: deleteTraces,
      getTraceTTRTrendBySeverity: getTraceTTRTrendBySeverity,
      getRemediationPolicyViolations: getRemediationPolicyViolations,
      //Report section
      getNewTrendData: getNewTrendData,
      getTotalTrendData: getTotalTrendData,
      updateSeverity: updateSeverity
    }

    function getVulnerability(traceUuid, expandValue) {
      return $http.get(
        UserService.buildAPIUrl('/orgtraces/filter/' + traceUuid),
        { params: { expand: expandValue } }
      )
    }

    function getVulnerabilityShort(traceUuid, expandValue) {
      return $http.get(
        UserService.buildAPIUrl('/orgtraces/' + traceUuid + '/short'),
        { params: { expand: expandValue } }
      )
    }

    function getVulnerabilityVisibility(traceUuid) {
      return $http.get(
        UserService.buildAPIUrl('/orgtraces/' + traceUuid + '/visible')
      )
    }

    function markStatus(data) {
      return $http.put(UserService.buildAPIUrl('/orgtraces/mark'), data)
    }

    function shareViaEmail(data) {
      return $http.post(UserService.buildAPIUrl('/orgtraces/share/email'), data)
    }

    function deleteTraces(data) {
      return $http['delete'](UserService.buildAPIUrl('/orgtraces'), {
        data: data,
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function getTraceTTRTrendBySeverity(params) {
      return $http.get(
        UserService.buildAPIUrl('/orgtraces/stats/ttr/severity/trend'),
        {
          params: params
        }
      )
    }

    function getRemediationPolicyViolations() {
      return $http.get(UserService.buildAPIUrl('/orgtraces/policy/violations'))
    }

    //Report section
    function getNewTrendData(interval, params) {
      var httpTimeout = $q.defer()

      var request = $http({
        method: 'get',
        url: UserService.buildAPIUrl(
          '/orgtraces/stats/trend/' + interval + '/new'
        ),
        params: params,
        timeout: httpTimeout.promise
      })

      var promise = request.then()
      promise._httpTimeout = httpTimeout
      return promise
    }

    function getTotalTrendData(interval, params) {
      var httpTimeout = $q.defer()

      var request = $http({
        method: 'get',
        url: UserService.buildAPIUrl(
          '/orgtraces/stats/trend/' + interval + '/total'
        ),
        params: params,
        timeout: httpTimeout.promise
      })

      var promise = request.then()
      promise._httpTimeout = httpTimeout
      return promise
    }

    function updateSeverity(traceUuid, data) {
      return $http.put(
        UserService.buildAPIUrl('/orgtraces/trace/' + traceUuid + '/severity'),
        data
      )
    }
  }
})()
